<template lang="html">

  <div class="contenedor-predictivo" :type="(multiple) ? 'multiple' : 'single'" :likeSelect="likeSelect" @blur="ocultar" @mouseleave="ocultar">

    <input type="text" 
    @keyup="choose=false"
    @click="desplegar"
    v-model="search"
    @keyup.esc="ocultar"
    autocomplete="nope"
    v-if="!!!isArray"
    :placeholder="(!!placeholder) ? placeholder : 'Escribe para filtrar'">

    <input type="text" 
    @click="desplegar"
    v-model="selected"
    @keyup.esc="ocultar"
    autocomplete="nope"
    v-if="!!isArray"
    :placeholder="(!!placeholder) ? placeholder : 'Escribe para filtrar'">

    <div class="contenedor-opciones" v-if="(!!opcionesFilter && !choose && !!search) || (likeSelect && desplegado && !choose)">

      <template v-for="opcion in opcionesFilter" v-if="opcionesFilter.length != 0">

        <div class="opcion" v-if="multiple">
        

          <template v-if="typeof opcion == 'object'">
            <template v-if="!!!keyid">
              <input type="checkbox" :value="opcion[0]" :name="opcion[0]" v-model="selected" :id="opcion[0]" @change="$emit('input',selected)">
              <label :for="opcion[0]">{{opcion[1]}}</label>
            </template>

            <template v-if="!!keyid">
              <input type="checkbox" :value="opcion[keyid]" :name="opcion[0]" v-model="selected" :id="opcion[0]" @change="$emit('input',selected)">
              <label :for="opcion[0]">{{opcion[1]}}</label>
            </template>
          </template>

          <template v-if="typeof opcion == 'number'">
              <input type="checkbox" :value="opcion" :name="opcion" v-model="selected" :id="opcion" @change="$emit('input',selected)">
              <label :for="opcion">{{opcion}}</label>
          </template>
          
        </div>

        <div class="opcion" v-if="!multiple">
          <a @click="setSelected(opcion)">
            <template v-if="typeof opcion == 'string'">{{opcion}}</template>
            <template v-if="typeof opcion == 'object'">{{opcion[1]}}</template>
            <template v-if="!!searchIn">{{opcion[searchIn]}}</template>
          </a>
        </div>

      </template>

      <div class="opcion" v-if="!multiple && alwaysFind && opcionesFilter.length == 0">
        <a @click="setSelectedSearched(search)">{{search}}</a>
      </div>

      <div class="opcion" v-if="opcionesFilter.length == 0 && !!!alwaysFind">
        <label>No hay resultados</label>
      </div>
    </div>
  </div>

</template>

<script lang="js">

    import {mapGetters,mapActions} from 'vuex';
  
    export default  {
      name: 'predictivo',
      props: ['options','placeholder','multiple','searchIn','likeSelect','preselected','alwaysFind','keyid','isArray'],
      mounted(){
        if(!!this.preselected){

          if(typeof this.preselected != "object"){
            this.search = this.preselected;
          }else{
            this.selected = this.preselected;
          }



          this.choose = true;
        }
      },
      data() {
        return {
          search : '',
          selected : [],
          choose: false,
          desplegado : false
        }
      },
      computed: {
          ...mapGetters({
          colors : 'basicColors',
          style : 'getStyles',
        }),
        opcionesFilter(){
          let filters; 
          
            let search = (!!this.search) ? this.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : '';
            if(!!this.options){
              filters = this.options.filter(e =>{
                let can  = false;
                if(!!!this.searchIn){
                  
                  if(typeof e == "string"){
                    can = e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search.toLowerCase());
                  }else if(typeof e == "object"){
                    can = e[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search.toLowerCase())
                  }else if(typeof e == 'number'){
                    can = e.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search.toLowerCase())
                  }
                }else{
                  can = e[this.searchIn].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search.toLowerCase())
                }

                return can;

              });
          }
          return filters;
        }
      },
      methods: {
        emit(){
          if(!!!this.keyid){
            this.$emit('input', this.selected)
          }else{
            this.$emit('input', this.selected[this.keyid])
          }
          this.$emit("change");
        },
        erase(){
          this.search = '';
          this.selected = [];
        },
        setSelectedSearched(option){
          this.search = option[this.searchIn];
          this.selected = option;
          this.choose = true;
          this.$emit('input', this.selected)
          this.$emit("change");
        },
        setSelected(option){

    
          if(!!!this.searchIn){
            if(typeof option == 'string'){
              this.search = option;
            }else if(typeof option == 'object'){
              this.search = option[1];
            }
          }else{
            this.search = option[this.searchIn];
          }

          
          this.selected = option;
          this.choose = true;
          this.emit();
          
        },
        desplegar(){
          this.desplegado = true;
          this.choose = false;
        },
        ocultar(){
          this.desplegado = false;
          this.choose = true;
        }
      }
    }
  </script>
<style scoped lang="scss">
  .contenedor-predictivo{
    position: relative;
    &[likeselect=true] input{
      background: url("/static/img/icons/down-arrow.svg") calc(100% - 5px) center/10px no-repeat;
      padding-right: 20px;
    }
  }

  [dark=true]{
    .contenedor-predictivo{
    &[likeselect=true] input{
      background: url("/static/img/icons/down-arrow-white.svg") calc(100% - 5px) center/10px no-repeat;
    }
  } 
  }


  .contenedor-opciones{
    position: absolute;
    left: 0;
    bottom: 0;
    max-height: 400px;
    background: white;
    overflow: scroll;
    min-width: 500px;
    width: 100%;
    z-index: 10;
    padding-top: 10px;
    padding-bottom: 0;
    transform: translateY(100%);
    border:1px solid rgb(155, 155, 155);
    max-height: 250px;
    
  }

  .opcion{
    padding: 0 10px;
    &:hover,
    &:focus {
      background: rgba(0,0,0,.2);
    }
  }

  .contenedor-opciones input[type="checkbox"] + label,
  .contenedor-opciones input[type="radio"] + label{
    font-size: 12px;
    line-height: 30px;
  }

  .contenedor-opciones input[type="radio"] + label::before{
    display: none;
  }

  .contenedor-opciones input[type="radio"] + label{
    padding-left: 0;
    cursor: pointer;
  }

  .contenedor-opciones a{
    font-size: 12px;
    line-height: 30px;
    width: 100%;
    text-align: left;
    display: inline-block;
    background: transparent;
    border:none;
    outline: none;
  }

  </style>


// WEBPACK FOOTER //
// src/components/parts/predictivo.vue